import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Material UI
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import { makeStyles } from 'tss-react/mui';
import { Box } from '@arredo/reactjs-ui'

// Icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReplyIcon from '@mui/icons-material/Reply';
import BlockIcon from '@mui/icons-material/Block';
import ReceiptIcon from '@mui/icons-material/Receipt';
import EditIcon from '@mui/icons-material/Edit';
import LoopIcon from '@mui/icons-material/Loop';
import DescriptionIcon from '@mui/icons-material/Description';
import RepeatIcon from '@mui/icons-material/Repeat';
import CancelIcon from '@mui/icons-material/Cancel';

// Components
import { Spinner } from '@arredo/reactjs-ui';
import { HistoryButton } from '../history';

//Hooks
import useUser from '../../../hooks/user/useUser';
import useAuthorize from '../../../hooks/user/useAuthorize';

//Model
import { Permissions } from '../../../models/Roles';
import { CanVoid, CanRefund, CanEdit, CanInvoice, CanChange, CanCreateCI, CanChangeOtherBranch, CanRetryOperation, CanCancelSale, CanCancelOperation } from '../../../models/OrderEntity';
import { HighlightOff } from '@mui/icons-material';

const useStyles = makeStyles()(theme => ({
    paper: {
        padding: theme.spacing(2)
    }
}))

const TitleDetail = ({ order, loading, onInvoice, onVoid, onRefund, onChangeClick, onInternalVoucher, onRetryOperation, onCancel, onCancelOperation }) => {
    const { classes } = useStyles();
    const { branch } = useUser();
    const isAuthorized = useAuthorize();
    const history = useNavigate();
    const location = useLocation();


    const edit = () =>
        history(`/orders/${order.id}`);

    const goBack = () =>
        history(location.state?.from || "/orders");

    return (
        <Box
            header={
                <Grid
                    container
                    spacing={1}
                    alignItems='center'
                    size={{
                        xs: 12,
                        sm: "grow"
                    }}
                >
                    <Grid>
                        <IconButton color='primary' onClick={goBack} size="large">
                            <ArrowBackIcon />
                        </IconButton>
                    </Grid>
                    <Grid>
                        <Typography variant='h5' component='h4'>
                            Informacion sobre la Orden
                        </Typography>
                    </Grid>
                </Grid>
            }
            actions={
                <>
                    {loading && <Spinner lockScreen />}
                    <Grid container alignItems='center' alignContent='center'>
                        <Grid item>
                            {order?.history && <HistoryButton orderId={order.id} />}
                            {isAuthorized([Permissions.SalesInvoince]) && CanInvoice(order, branch.code) &&
                                <Tooltip title='Facturar' aria-label='Facturar'>
                                    <IconButton onClick={onInvoice} size="large">
                                        <ReceiptIcon color='primary' />
                                    </IconButton>
                                </Tooltip>}
                            {isAuthorized([Permissions.SalesEdit]) && CanEdit(order, branch.code) &&
                                <Tooltip title='Editar' aria-label='Editar'>
                                    <IconButton onClick={edit} color='primary' size="large">
                                        <EditIcon color='primary' />
                                    </IconButton>
                                </Tooltip>}
                            {isAuthorized([Permissions.SalesEdit]) && CanChange(order, branch.code) &&
                                <Tooltip title='Realizar Cambio' aria-label='cambio'>
                                    <IconButton color="primary" onClick={onChangeClick} size="large">
                                        <LoopIcon />
                                    </IconButton>
                                </Tooltip>}
                            {isAuthorized([Permissions.SalesEdit]) && CanChangeOtherBranch(order, branch) &&
                                <Tooltip title='Cambio de otra sucursal' aria-label='Cambio de otra sucursal'>
                                    <IconButton onClick={onChangeClick} size="large">
                                        <LoopIcon color='primary' />
                                    </IconButton>
                                </Tooltip>}
                            {isAuthorized([Permissions.SalesRefund]) && CanRefund(order, branch.code) &&
                                <Tooltip title='Devolver' aria-label='Devolución parcial'>
                                    <IconButton onClick={onRefund} size="large">
                                        <ReplyIcon color='primary' />
                                    </IconButton>
                                </Tooltip>}
                            {isAuthorized([Permissions.SalesVoid]) && CanVoid(order, branch) &&
                                <Tooltip title='Devolución total' aria-label='Devolución total'>
                                    <IconButton onClick={onVoid} size="large">
                                        <BlockIcon color='primary' />
                                    </IconButton>
                                </Tooltip>}
                            {isAuthorized([Permissions.ComprobanteInter]) && CanCreateCI(order, branch.code) &&
                                <Tooltip title='Comprobante Interno' aria-label='Comprobante Interno'>
                                    <IconButton onClick={onInternalVoucher} size="large">
                                        <DescriptionIcon color='primary' />
                                    </IconButton>
                                </Tooltip>}
                            {isAuthorized([Permissions.SalesRefund]) && CanRetryOperation(order, branch.code) &&
                                <Tooltip title='Reintentar operación' aria-label='Reintentar operación'>
                                    <IconButton onClick={onRetryOperation} size="large">
                                        <RepeatIcon color='primary' />
                                    </IconButton>
                                </Tooltip>}
                            {CanCancelSale(order, branch.code) &&
                                <Tooltip title='Cancelar' aria-label='Cancelar'>
                                    <IconButton onClick={onCancel} size="large">
                                        <CancelIcon color='primary' />
                                    </IconButton>
                                </Tooltip>}
                            {CanCancelOperation(order, branch.code) &&
                                <Tooltip title='Cancelar Operación' aria-label='Cancelar'>
                                    <IconButton onClick={onCancelOperation} size="large">
                                        <HighlightOff color='primary' />
                                    </IconButton>
                                </Tooltip>}
                        </Grid>
                    </Grid>
                </>
            }
        />
    );
}

export default TitleDetail;